import { SortFieldDescriptor } from "@springtree/eva-services-core";
import { createContext, Dispatch, SetStateAction, useContext, useState } from "react";

import Eva from "~/services/eva";

const Context = createContext<
  | {
      query: string;
      sort: SortFieldDescriptor[];
      setSort: Dispatch<SetStateAction<SortFieldDescriptor[]>>;
    }
  | undefined
>(undefined);

export default function SearchProvider(props: { query: string; children: React.ReactNode }) {
  const [sort, setSort] = useState(Eva.DEFAULT_CATEGORY_SORT);

  return <Context.Provider value={{ query: props.query, sort, setSort }}>{props.children}</Context.Provider>;
}

export function useSearch() {
  const context = useContext(Context);

  if (!context) {
    throw new Error(`useSearch must be used within a SearchProvider`);
  }

  return context;
}
